import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import React, {ReactElement, useContext} from "react";
import {ResourceAccessRole, ResourceNode, ResourceType} from "./types";
import {StyledBoxColumn} from "../shared/StyledComponents";
import {Render, Renderable} from "../shared/types";
import {CreateProjectView} from "./CreateProjectHelper";
import {PathProps} from "../shared";
import {ResourceContext} from "./contexts";
import {Card, Typography} from "@mui/material";
import {ProjectSelectView} from "./components/ProjectSelectView";
import {PAGE_FRAGMENT_WIDTH} from "../shared/dimens";

function RequiresProjectRenderer(props: { path: PathProps, renderer: Renderable }): ReactElement {
  const context = useContext(ResourceContext);
  const projects = context.resources.filter(res => res.getType() === ResourceType.PROJECT);
  if (context.accessRole !== ResourceAccessRole.LABELER && !(projects?.length > 0)) {
    return <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
      <Card>
        <CreateProjectView onProjectCreated={() => window.location.reload()}/>
      </Card>
    </div>;
  }
  if (context.selectedResource?.getResourceNode().type !== ResourceType.PROJECT) {
    return <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
      <StyledBoxColumn style={{width: "100%", maxWidth: PAGE_FRAGMENT_WIDTH}}>
        <Typography variant={"h6"}>Select a project to view this page</Typography>
        <ProjectSelectView/>
      </StyledBoxColumn>
    </div>;
  }
  return Render(props.renderer, props.path);
}

export function requiresProject(renderer: (path: PathProps) => ReactElement): (path: PathProps) => ReactElement {
  return (path: PathProps) => <RequiresProjectRenderer path={path} renderer={renderer}/>;
}

export type BaseModuleMainProps = BaseFragmentProps & {
  modulePath?: string,
}

export type BaseModuleMainState = BaseFragmentState & {
  resources?: ResourceNode[],
  selectedResource?: ResourceNode,
}

export abstract class BaseModuleMain<P extends BaseModuleMainProps = BaseModuleMainProps, S extends BaseModuleMainState = BaseModuleMainState> extends BaseFragment<P, S> {
}